// LE ICONE DELLO SCENE EDITOR E DEL COMPOSER, da un punto solo: il rail, l'Outliner, le barre dei
// comandi, il viewport e le librerie importano da qui.
//
// SONO MATERIAL ICONS CLASSICHE (utente, 2026-10-02), le stesse del resto di Zakeke. Prima erano i
// glifi del prototipo, a tratto; la migrazione li ha portati tutti qui uno per uno, e chi importa
// non ha cambiato niente. L'unico glifo rimasto è «visibilità mista»: la classica non ha un occhio a
// metà, e lo stato misto non deve confondersi con acceso o spento.
//
// Le icone Material sono piene e senza colore proprio: `material()` le colora con `currentColor`,
// come facevano i glifi col tratto. Un `fill` nel CSS di chi le ospita vince comunque.
//
// NEVER give `eyeMixed.svg` a `width` or `height` attribute. SVGO drops the viewBox when it is
// redundant with them, and a glyph with no viewBox is drawn at 1:1 user units inside a 14 or 17
// pixel box. Size it from the CSS of whoever hosts it.

import React from 'react';
import AddSvg from 'src/shared/material_icons/content/add.svg';
import DeleteSvg from 'src/shared/material_icons/action/delete.svg';
import ContentCopySvg from 'src/shared/material_icons/content/content_copy.svg';
import EditSvg from 'src/shared/material_icons/image/edit.svg';
import MoreVertSvg from 'src/shared/material_icons/navigation/more_vert.svg';
import VisibilitySvg from 'src/shared/material_icons/action/visibility.svg';
import VisibilityOffSvg from 'src/shared/material_icons/action/visibility_off.svg';
import LockSvg from 'src/shared/material_icons/action/lock.svg';
import LockOpenSvg from 'src/shared/material_icons/action/lock_open.svg';
import ExpandMoreSvg from 'src/shared/material_icons/navigation/expand_more.svg';
import CloseSvg from 'src/shared/material_icons/navigation/close.svg';
import LinkSvg from 'src/shared/material_icons/content/link.svg';
import RestartAltSvg from 'src/shared/material_icons/device/restart_alt.svg';
import VtoSvg from 'src/shared/material_icons/legacy/VTO.svg';
import VideoCameraFrontSvg from 'src/shared/material_icons/image/video_camera_front.svg';
import LayersSvg from 'src/shared/material_icons/maps/layers.svg';
import LightbulbSvg from 'src/shared/material_icons/action/lightbulb.svg';
import VideocamSvg from 'src/shared/material_icons/av/videocam.svg';
import TextureSvg from 'src/shared/material_icons/image/texture.svg';
import WallpaperSvg from 'src/shared/material_icons/device/wallpaper.svg';
import PublicSvg from 'src/shared/material_icons/social/public.svg';
import PanoramaSvg from 'src/shared/material_icons/image/panorama.svg';
import AutoAwesomeMotionSvg from 'src/shared/material_icons/image/auto_awesome_motion.svg';
import HighlightAltSvg from 'src/shared/material_icons/action/highlight_alt.svg';
import AdjustSvg from 'src/shared/material_icons/image/adjust.svg';
import ViewInArSvg from 'src/shared/material_icons/action/view_in_ar.svg';
import JoinInnerSvg from 'src/shared/material_icons/action/join_inner.svg';
import FolderSvg from 'src/shared/material_icons/file/folder.svg';
import UploadSvg from 'src/shared/material_icons/file/upload.svg';
import DownloadSvg from 'src/shared/material_icons/file/download.svg';
import SaveSvg from 'src/shared/material_icons/content/save.svg';
import NorthEastSvg from 'src/shared/material_icons/navigation/north_east.svg';
import SwapHorizSvg from 'src/shared/material_icons/action/swap_horiz.svg';
import NearMeSvg from 'src/shared/material_icons/maps/near_me.svg';
import OpenWithSvg from 'src/shared/material_icons/action/open_with.svg';
import RotateRightSvg from 'src/shared/material_icons/image/rotate_right.svg';
import OpenInFullSvg from 'src/shared/material_icons/action/open_in_full.svg';
import CenterFocusStrongSvg from 'src/shared/material_icons/image/center_focus_strong.svg';
import GridOnSvg from 'src/shared/material_icons/image/grid_on.svg';
import ThreeDRotationSvg from 'src/shared/material_icons/action/3d_rotation.svg';
import UnfoldMoreSvg from 'src/shared/material_icons/navigation/unfold_more.svg';
import UnfoldLessSvg from 'src/shared/material_icons/navigation/unfold_less.svg';
import PreviewSvg from 'src/shared/material_icons/action/preview.svg';
import FullscreenSvg from 'src/shared/material_icons/navigation/fullscreen.svg';
import FullscreenExitSvg from 'src/shared/material_icons/navigation/fullscreen_exit.svg';
import GridViewSvg from 'src/shared/material_icons/file/grid_view.svg';
import ViewListSvg from 'src/shared/material_icons/action/view_list.svg';
import FilterListSvg from 'src/shared/material_icons/content/filter_list.svg';
import LanguageSvg from 'src/shared/material_icons/action/language.svg';

const material = (Svg: React.FunctionComponent<React.SVGAttributes<SVGElement>>) => {
    const MaterialIcon = (props: React.SVGAttributes<SVGElement>) => <Svg fill='currentColor' {...props} />;
    return MaterialIcon;
};

// I COMANDI: aggiungi, elimina, duplica, rinomina, «…», visibilità, lucchetto, frecce, chiudi, collega.
export const PlusIcon = material(AddSvg);
export const TrashIcon = material(DeleteSvg);
export const DuplicateIcon = material(ContentCopySvg);
export const RenameIcon = material(EditSvg);
export const DotsIcon = material(MoreVertSvg);
export const EyeIcon = material(VisibilitySvg);
export const EyeOffIcon = material(VisibilityOffSvg);
export const LockIcon = material(LockSvg);
export const LockOpenIcon = material(LockOpenSvg);
export const ChevronIcon = material(ExpandMoreSvg);
export const CloseIcon = material(CloseSvg);
export const LinkIcon = material(LinkSvg);
/** Riporta un valore a quello di partenza: il «reset» dei campi del pannello proprietà. */
export const ResetIcon = material(RestartAltSvg);
/**
 * IL VTO HA LA SUA ICONA, quella con la scritta che usa l'Asset library del DAM: la stessa cosa si riconosce
 * dallo stesso segno nei due posti. Non è una Material, e porta il suo grigio.
 */
export const VtoIcon = VtoSvg;

export { default as EyeMixedIcon } from './eyeMixed.svg';

// SEZIONI, NODI DELL'OUTLINER, LIBRERIE, STRUMENTI DEL VIEWPORT E VISTE.
export const ObjectsIcon = material(LayersSvg);
export const LightsIcon = material(LightbulbSvg);
export const CamerasIcon = material(VideocamSvg);
export const MaterialsIcon = material(TextureSvg);
export const TexturesIcon = material(WallpaperSvg);
export const EnvironmentsIcon = material(PublicSvg);
export const WorldIcon = material(PanoramaSvg);
export const EffectsIcon = material(AutoAwesomeMotionSvg);
export const SelectedIcon = material(HighlightAltSvg);
export const EmptyNodeIcon = material(AdjustSvg);
export const MeshNodeIcon = material(ViewInArSvg);
export const GroupIcon = material(JoinInnerSvg);
export const FolderIcon = material(FolderSvg);
export const UploadIcon = material(UploadSvg);
export const ImportAssetIcon = material(DownloadSvg);
export const SaveAssetIcon = material(SaveSvg);
export const RevealIcon = material(NorthEastSvg);
export const SwapIcon = material(SwapHorizSvg);
export const GlobalSpaceIcon = material(LanguageSvg);
export const LocalSpaceIcon = material(ViewInArSvg);
export const SelectToolIcon = material(NearMeSvg);
export const MoveToolIcon = material(OpenWithSvg);
export const RotateToolIcon = material(RotateRightSvg);
export const ScaleToolIcon = material(OpenInFullSvg);
export const FrameSelectionIcon = material(CenterFocusStrongSvg);
export const GridIcon = material(GridOnSvg);
export const AxisIcon = material(ThreeDRotationSvg);
export const ExplodeIcon = material(UnfoldMoreSvg);
export const CollapseIcon = material(UnfoldLessSvg);
export const PreviewModeIcon = material(PreviewSvg);
export const FullscreenIcon = material(FullscreenSvg);
export const FullscreenExitIcon = material(FullscreenExitSvg);
export const ViewGridIcon = material(GridViewSvg);
export const ViewListIcon = material(ViewListSvg);
export const FilterIcon = material(FilterListSvg);
/** La vista libera della sezione Cameras, quella che si usa quando non si guarda da una camera salvata. */
export const FreeCameraIcon = material(VideoCameraFrontSvg);
